// extracted by mini-css-extract-plugin
export default {"lightboxHeader":"KmhS_dH58wCjsVQdBC9y","backButton":"IDCDXPIDnfB08hr8eBGq"};